import InsertBlocksCommand from './insert-blocks';
import Command from './command';
import parseMarkdown from '@intercom/embercom-composer/lib/markdown-parser';
import intermoji from '@intercom/intermoji';
import htmlToBlocks from '../../lib/html-to-blocks';
import htmlToSingleBlock from '../../lib/html-to-single-block';
import textToBlocks from '../../lib/text-to-blocks';
import textToSingleBlock from '../../lib/text-to-single-block';
import { hasNativeEmojiSupport } from '@intercom/embercom-composer/lib/intermoji';
import Em from 'ember';
export default Command.extend({
  processZeroWidth() {
    return this._insertBlocks();
  },
  processSingleBlock() {
    return this._insertBlocks();
  },
  processMultiBlock() {
    return this._insertBlocks();
  },
  _getBlocks() {
    let string = this.get('options.string');
    string = this._replaceEmoji(string);
    let type = this.get('options.type');
    let singleBlock = this.get('options.singleBlock');
    let config = this.get('config');
    if (type === 'html') {
      string = parseMarkdown(string);
      return singleBlock ? htmlToSingleBlock(string, config, this.get('options.uploadManager')) : htmlToBlocks(string, config, this.get('options.uploadManager'));
    }
    if (type === 'plain' || Em.isEmpty(type)) {
      return singleBlock ? textToSingleBlock(string, config) : textToBlocks(string, config);
    }
    throw new Error('Invalid content type passed to paste');
  },
  _insertBlocks() {
    let blocks = this._getBlocks();
    return InsertBlocksCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      config: this.get('config'),
      options: {
        blocks
      }
    }).run();
  },
  _replaceEmoji(text) {
    if (this.get('config.allowEmoji') && hasNativeEmojiSupport()) {
      return intermoji.substituteUnicodeForColonified(text);
    }
    return text;
  }
});